export default {
  name: 'PolteqTextField',
  props: ['fieldId', 'label', 'icon', 'type', 'autocomplete', 'rules', 'readonly']
};
